$(function () {

    //find IndexMethod polyfill for IE
    if (!Array.prototype.findIndex) {
        Object.defineProperty(Array.prototype, 'findIndex', {
            value: function(predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];

                // 5. Let k be 0.
                var k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return k.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return k;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return -1.
                return -1;
            },
            configurable: true,
            writable: true
        });
    }


    function showPrice() {
        setTimeout(function(){
            $('#date-selection .ui-datepicker-calendar tbody td').each(function () {
                if($(this).hasClass('has-price')) {
                    var results = $(this).attr("class").match(/price-\d+/i);
                    var price = results&&results.length>0?results[0].split('-')[1]:'0';
                    if($.isNumeric(price) && price !== '0') { 
                        $(this).append('<span class="price">$'+price+'</span>');
                    } else {
                        $(this).append('<span class="sold-out">Sold Out</span>');
                    }

                    /* MinLos */
                    var results = $(this).attr("class").match(/min_los-\d+/i);
                    var minlos = results&&results.length>0?results[0].split('-')[1]:'0';
                    if($.isNumeric(minlos) && minlos > 1 ) {
                        $(this).append('<span class="min_los">'+minlos+' min nts</span>');
                    }
                }
            });
        },  0);
        console.log('update prices');
    }

    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

    function changeDateHTML(targetReal, day, monthnum, year, targetFake){
        var month = months[monthnum]
        var formatMonth = monthnum + 1;
        formatMonth = formatMonth < 10 ? '0' + monthnum : formatMonth;
        targetReal.val(year + '-' + formatMonth + '-' + day);
        targetFake.text(month + "-"+ day + "-" + year);
    }

    const CheckIn__selector = $("#CheckIn"),
        CheckOut__selector = $("#CheckOut"),
        CheckIn__selector_fake = $("#datedummyIn"),
        CheckOut__selector_fake = $("#datedummyOut");

    $.post(site_url + "ajax/functions.php", {
        operation: 'getDayPricesFromTravelTripper',
        hotel_id: "TEMCRK",
        rate_code: 'BAR0',
        portal_id: "temeculacreekinn",
        number_of_months: 12 
    }, function(data) {

        const dataDates = data.dates;
        const dataPrices =  data.prices;
        const dataMinlos =  data.min_los;
        const dataAvailable = data.available;
        console.log(data);
        $.datepicker._defaults.dateFormat = "yy-mm-dd";

        var d1 = new Date();
        var d2 = new Date(2020, 9, 1);
        var minimunDate = 0;
        if( d1 < d2 ){
            minimunDate = d2;
        }

        $('#date-selection').datepicker({
            inline: true,
            numberOfMonths: 2,
            minDate: minimunDate,
            changeMonth: false,
            maxDate: "+1y",
            beforeShowDay: function(date) {
                let startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim($("#CheckIn--alt").val())),
                endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim($("#CheckOut--alt").val())),
                dmy =  date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2) ;
                var style;
                if ($.inArray(dmy, dataDates) != -1) {
                    let index = dataDates.findIndex(x =>x==dmy);
                    if( startDate && date.getTime() == startDate.getTime() ){
                        style = "startday ";
                    }else if( endDate && date.getTime() == endDate.getTime()){
                        style = "endday ";
                    }else if(startDate && date.getTime() > startDate && date.getTime() <= endDate){
                        style = "dp-highlight ";
                    }
                    //return [true,' has-price ' + style + 'price-' + dataPrices[index] + ' min_los-' + dataMinlos[index] ];
                    return [true, ' has-price ' +  style + 'price-' + dataPrices[index]];
                } else {
                    return [true, startDate && ((date.getTime() == startDate.getTime()) || (endDate && date >= startDate && date <= endDate) ) ? "dp-highlight" : ""];
                }
            },
            onChangeMonthYear: function(date) {
                showPrice();
            },
            onSelect: function (date) {
                // console.log('onSelect', date);
                let date1 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim( $("#CheckIn--alt").val()) ),
                    date2 = $.datepicker.parseDate($.datepicker._defaults.dateFormat, $.trim( $("#CheckOut--alt").val()) ),
                    selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date),

                //DATE SELECTED
                thisDate = $(this).datepicker('getDate'),
                    day  = thisDate.getDate(),
                    monthnum = thisDate.getMonth(),
                    year = thisDate.getFullYear();

                if (!date1 || date2) {
                    $("#CheckIn--alt").val(date);
                    $("#CheckOut--alt").val("");
                    changeDateHTML(CheckIn__selector, day, monthnum, year, CheckIn__selector_fake);
                    // console.log('checkin');
                    $("#CheckIn").val(date);
                } else if( selectedDate < date1 ) {
                    $("#CheckIn--alt").val(date);
                    $("#CheckOut--alt").val("");
                    changeDateHTML(CheckIn__selector, day, monthnum, year, CheckIn__selector_fake);
                    // console.log('change dates');
                    $("#CheckIn").val(date);
                } else {
                    $("#CheckOut--alt").val(date);

                    changeDateHTML(CheckOut__selector, day, monthnum, year, CheckOut__selector_fake);
                    $("#CheckOut").val(date);
                    // console.log('checkout');
                }
                showPrice();
            }
        });
        showPrice();

    }, "json");

});